import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import OptionsPopup from "./OptionsPopup"; // Adjust the import path as needed
import "./SortableDragAndDrop.scss"; // Import CSS for styling

import { useSelector, useDispatch } from "react-redux";
import useClickOutside from "../../../hooks/useClickOutside";

import cloneDeep from "lodash.clonedeep";
import * as UTILS from "../../../utils/Utils";
import * as actionTypes from "../../../store/Actions/actions";

import SettingsIcon from "../../../assets/images/settingNav.svg";
import DragIcon from "../../../assets/images/dragHandle.svg";

const SortableItem = SortableElement(({ value, actions, index, itemKey }) => {
  const [isActive, setIsActive] = useState(false);

  const settingRef = useRef(null);
  useClickOutside(settingRef, () => setIsActive(false));

  const handleMenu = (e) => {
    e.preventDefault();
    setIsActive(!isActive);
  };
  return (
    <div className="sortable-item">
      <div style={{ display: "flex", gap: "10px" }}>
        <img
          draggable="false"
          src={DragIcon}
          onDragStart={(e) => e.preventDefault()}
        />
        {value.title}
      </div>

      <div
        style={{ cursor: "pointer" }}
        onMouseDown={handleMenu}
        onDragStart={(e) => e.preventDefault()}
        ref={settingRef}
      >
        <img
          src={SettingsIcon}
          onDragStart={(e) => e.preventDefault()}
        />
        {isActive && (
          <OptionsPopup
            className="options-popup"
            index={itemKey}
            actions={actions}
          />
        )}
      </div>
    </div>
  );
});

const SortableList = SortableContainer(
  ({ items, actions, setOptionsPopupIndex, optionsPopupIndex }) => {
    const [sortableItems, setSortableItems] = useState(items);

    useEffect(() => {
      setSortableItems(items);
    });
    return (
      <div className="sortable-container">
        {sortableItems &&
          sortableItems.map(
            (item, index) =>
              item && (
                <SortableItem
                  itemKey={item.key}
                  index={index}
                  value={item}
                  actions={actions}
                  setOptionsPopupIndex={setOptionsPopupIndex}
                  optionsPopupIndex={optionsPopupIndex}
                />
              )
          )}
      </div>
    );
  }
);

const SortableDragAndDrop = ({
  initialItems,
  actions,
  element,
}) => {
  const [optionsPopupIndex, setOptionsPopupIndex] = useState(null);
  const [sortableItems, setSortableItems] = useState(initialItems);
  const { layout, layoutTitle } = useSelector((state) => state.present);
  const dispatch = useDispatch();

  const onSortEnd = ({ oldIndex, newIndex }) => {
    let newArray = cloneDeep(sortableItems);
    const newItems = arrayMove(newArray, oldIndex, newIndex);
    var newObject = Object({});
    let newOrder = newItems.map((item) => item.key);
    newOrder.forEach((key) => {
      if (element.columns.hasOwnProperty(key))
        newObject[key] = element.columns[key];
    });

    const newLayout = UTILS.UpdateLayout(
      layout,
      element.id,
      (item) => {
        item.columns = newObject;
      },
      (colItem) => {
        colItem.columns = newObject;
      }
    );

    dispatch(
      actionTypes.layout({ titleLayout: layoutTitle, layout: newLayout })
    );
  };

  const handleClickOutside = (event) => {
    if (!event.target.closest(".sortable-item")) {
      setOptionsPopupIndex(null);
    }
  };

  useEffect(() => {
    setSortableItems(initialItems);
    if (optionsPopupIndex !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  return (
    <div>
      <SortableList
        items={sortableItems}
        actions={actions}
        onSortEnd={onSortEnd}
        setOptionsPopupIndex={setOptionsPopupIndex}
        optionsPopupIndex={optionsPopupIndex}
      />
    </div>
  );
};

SortableDragAndDrop.propTypes = {
  initialItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
SortableList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
SortableItem.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  index: PropTypes.number.isRequired,
  itemKey: PropTypes.string.isRequired,
};

export default SortableDragAndDrop;
